export const ONLY_NUMBER_REGEX = /^\d+$/;
export const ALPHA_NUMERIC_REGEX = /^[a-zA-Z0-9]+$/;
export const ONLY_ALPHA_REGEX = /^[A-Za-z]+$/;
